export default "__VITE_ASSET__DacZUH$E__"